<script>
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import FilterTabs from '../FilterTabs/FilterTabs.svelte';
  import PaginationControl from '../PaginationControl/PaginationControl.svelte';

  let {
    headingTextTemplate,
    headingLevel,
    initialLimit,
    filterTabs,
    paginationControl,
    dataTestId = 'location-link-list',
    locations,
  } = $props();

  let expanded = false;
</script>

<div class="grow" data-testid={dataTestId}>
  {#if headingTextTemplate}
    <BaseHeading
      {headingLevel}
      className="px-4 text-blue-dark-navy font-semibold text-lg lg:text-1.5xl leading-tight mb-4 lg:mb-6"
    >
      {headingTextTemplate}
    </BaseHeading>
  {/if}
  {#if filterTabs}
    <div class="md:mx-4">
      <FilterTabs {...filterTabs} />
    </div>
  {/if}
  <ul class="mx-4 grid grid-cols-2 gap-x-4 pt-2 lg:pt-0 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
    {#each locations as { text, url }, index (index)}
      <li
        class="pb-4"
        class:hidden={!expanded && initialLimit && index >= initialLimit}
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
      >
        <BaseLink
          className="text-blue-cerulean hover-hover:hover:text-blue-darkish hover-hover:hover:underline active:text-blue-darkish active:underline"
          {url}
          {text}
        />
      </li>
    {/each}
  </ul>
  {#if paginationControl}
    <div class="max-w-56 mx-auto lg:pt-6">
      <PaginationControl {...paginationControl} rel="nofollow" />
    </div>
  {/if}
</div>
